export const CLASS_NAMES = {
  container: 'flex flex-col px-3 py-4 rounded-xl bg-neutral-100 mb-4 mt-4.5',
  emptyContainer: 'mb-4.5',
  title: 'text-style-h text-neutral-700',
};
